import { z } from "zod";

export const createExportSchema = z.object({
  dateFrom: z.date().optional(),
  dateTo: z.date().optional(),
});

export type CreateExport = z.infer<typeof createExportSchema>;
